<template>
  <div class="link-selector">
    <a
      v-if="fullPath"
      href="javascript:void(0)"
      :title="fullPath.pathText"
      class="link-selector__link"
    >
      <el-tag :closable="!disabled" @close="clearLink">
        <div class="link-selector__tag-content">{{ fullPath.pathText }}</div>
      </el-tag>
    </a>

    <el-cascader
      v-else
      v-model="link_types"
      :options="options"
      :props="props"
      :show-all-levels="false"
      :disabled="disabled"
      placeholder="请选择跳转链接"
      size="mini"
      @change="handleCascaderChange"
    />
    <en-shop-picker
      :show.sync="show_shop_picker"
      :buyer-domain="$$Domain['buyer_pc']"
      :request="$$Request"
      :limit="1"
      @confirm="handleShopPickerConfirm"
    />
    <!-- <en-goods-picker
      :show.sync="show_goods_picker"
      :type="$$DecorType"
      :limit="1"
      @confirm="handleGoodsPickerConfirm"
      @close="show_goods_picker = false"
    />
    <en-page-picker
      :show.sync="show_page_picker"
      :request="$$Request"
      :domain="$$Domain"
      :limit="1"
      type="decor"
      @confirm="handlePagePickerConfirm"
    /> -->
  </div>
</template>

<script>
import * as Rules from "@/utils/rules";
// import * as API_Shop from '@/api/shop'
import * as API_Pages from "@/api/pagesJson";
// import { clientType } from '@/utils/decor-types'

export default {
  name: "LinkSelector",
  props: {
    value: {
      type: [Object, String],
      required: true,
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      link: "",
      link_types: [],
      token: "",
      options: [
        {
          label: "微页面",
          value: "微页面",
          children: [
            // { label: "微页面", value: "mini-page" },
            // { label: "店铺主页", value: "shop-home" },
            // { label: "个人中心", value: "user-center" },
          ],
        },
        // {
        //   label: '商品',
        //   value: '商品',
        //   children: [
        //     { label: '全部商品', value: 'goods' },
        //     { label: '部分商品', value: 'part-goods' },
        //     { label: '购物车', value: 'cart' },
        //     { label: '分类', value: 'category' }
        //   ]
        // },
        // {
        //   label: '营销工具',
        //   value: '营销工具',
        //   children: [
        //     { label: '优惠券', value: 'coupons' },
        //     { label: '限时抢购', value: 'seckill' },
        //     { label: '拼团活动', value: 'assemble' }
        //   ]
        // },
        {
          label: "链接大全",
          value: "链接大全",
          children: [],
        },
        {
          label: "其他",
          value: "其他",
          children: [
            { label: "自定义链接", value: "custom" },
            // { label: '小程序路径', value: 'mini-program', disabled: clientType === 'pc' }
          ],
        },
      ],
      props: { expandTrigger: "hover" },
      shopInfo: "",
      show_shop_picker: false,
      show_goods_picker: false,
      show_page_picker: false,
      miniPageItem: "",
      shopItem: "",
    };
  },
  watch: {
    value: {
      immediate: true,
      handler: "defaultValueChange",
    },
  },
  model: { event: "update", prop: "value" },
  mounted() {
    this.token = this.$$Foundation.getURLSearchParma("token");
    this.shopItem = this.$$ShopInfo;
    this.businessType = this.$$Foundation.getURLSearchParma("businessType");
    API_Pages.getPageJson(this.token, this.businessType).then((res) => {
      res.data.list.forEach((item) => {
        item.label = item.pageName;
        item.value = item.id;
      });
      this.options[0].children =
        res.data?.list?.filter((el) => el.status != 0) || [];
      // 数据更新后重新解析回填link_types
      if (this.link && this.link.type) {
        this.defaultValueChange(this.link);
      }
    });
    API_Pages.getLinkPageJson(this.token, this.businessType).then((res) => {
      const list = res.data?.list || res.data || [];
      const typeMap = {
        '我的卡券': 'mycoupon',
        '我的积分': 'mypoints',
        '我的预约': 'myappointment',
        '我的订单': 'myorder',
        '我的余额': 'mybalance',
        '预约中心': 'appointmentcenter',
        '医生列表': 'doctorlist',
        '个人中心': 'usercenter',
      };
      list.forEach((item) => {
        item.label = item.pageName;
        item.value = item.id;
        item.type = typeMap[item.pageName] ;
      });
      this.options[1].children = list;
      // 数据更新后重新解析回填link_types
      if (this.link && this.link.type) {
        this.defaultValueChange(this.link);
      }
    });
  },
  computed: {
    fullPath() {
      if (!this.link || !this.link_types) return;
      const option = this.options.filter(
        (item) => item.value === this.link_types[0],
      )[0];
      const subOption = option.children.filter(
        (item) => item.value === this.link_types[1],
      )[0];
      let path = [option, subOption];
      let pathText = `${option.label} | ${subOption.label}`;
      if (subOption.value === "mini-page") {
        pathText = `微页面 | ${this.miniPageItem["page_name"] || "微页面"}`;
      }
      if (subOption.value === "shop-home" && this.shopItem) {
        pathText = `店铺首页 | ${this.shopItem["shop_name"]}`;
      }
      if (subOption.value === "custom") {
        pathText = `外链 | ${this.link.value}`;
      }
      if (subOption.value === "mini-program") {
        pathText = `小程序路径 | ${this.link.value}`;
      }
      // 链接大全显示
      if (this.link_types[0] === "链接大全" && this.link) {
        pathText = `链接大全 | ${this.link.name || subOption.label}`;
      }
      return { path, pathText };
    },
  },
  methods: {
    /**
     * 选择器值发生改变
     * @param item
     */
    async handleCascaderChange(item) {
      const link_type = item[item.length - 1];
      let link = { type: link_type, value: "" };
      switch (link_type) {
        case "custom":
          link.value = await this.inputCustomLink();
          break;
        case "mini-program":
          link.value = await this.inputMiniProgramLink();
          break;
        // case 'mini-page':
        //   this.show_page_picker = true
        //   link.value = undefined
        //   break
        // case 'shop-home':
        //   link.value = await this.getShopLink(); break
        case "user-center":
          link.value = `member`;
          break;
        case "part-goods":
          this.show_goods_picker = true;
          link.value = undefined;
          break;
        default:
          // 链接大全
          if (this.link_types[0] === "链接大全") {
            const selectedLink = this.options[1].children.find(
              (el) => el.id == link_type,
            );
            if (selectedLink) {
              link.type = selectedLink.type || 'mini-app-link';
              link.value = selectedLink.pagePath || selectedLink.pageUrl || selectedLink.pageCode || selectedLink.id;
              link.name = selectedLink.pageName;
              link.appId = selectedLink.appId;
            }
            break;
          }
          link.value = this.options[0].children.find(
            (el) => el.id == link_type,
          ).decorateConfig;
          link.name = this.options[0].children.find(
            (el) => el.id == link_type,
          ).pageName;
      }
      if (link.value === undefined) return this.clearLink();
      this.link = link;
      this.$emit("update", this.link);
    },
    /**
     * 清空值
     */
    clearLink() {
      this.$nextTick(() => {
        this.link = "";
        this.link_types = []; // 清空重置为空数组
      });
      this.$emit("update", "");
    },
    /**
     * 输入自定义链接
     * @returns {Promise<string>}
     */
    async inputCustomLink() {
      try {
        const res = await this.$prompt("请输入自定义链接", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputPlaceholder: "https://",
          inputPattern: Rules.url,
          inputErrorMessage: "链接格式不正确！",
        });
        return res.value;
      } catch (e) {
        this.clearLink();
      }
    },
    /**
     * 输入小程序路径
     * @returns {Promise<string>}
     */
    async inputMiniProgramLink() {
      try {
        const res = await this.$prompt("请输入小程序路径", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputPlaceholder: "请输入小程序路径",
        });
        return res.value;
      } catch (e) {
        this.clearLink();
      }
    },
    /**
     * 默认值发生改变
     * @param newVal
     */
    async defaultValueChange(newVal) {
      this.link = newVal;
      if (!newVal || !newVal.type) {
        this.link_types = "";
        return;
      }
      const targetType = newVal.type;
      let parentVal = "";
      let childVal = "";

      // 遍历一级分类
      outer: for (const parent of this.options) {
        // 遍历二级子项
        for (const child of parent.children || []) {
          // 优先匹配 type，再匹配 value（兼容微页面等用 id 做 value 的情况）
          if (child.type === targetType || child.value === targetType) {
            parentVal = parent.value;
            childVal = child.value;
            break outer;
          }
        }
      }
      // 组装级联选中数组 [一级,二级]
      if (parentVal && childVal) {
        this.link_types = [parentVal, childVal];
      } else {
        this.link_types = "";
      }
    },
    /**
     * 获取店铺链接
     * @returns {Promise<string>}
     */
    async getShopLink() {
      if (this.$$ShopInfo) {
        return this.$$ShopInfo["shop_id"];
      } else {
        this.show_shop_picker = true;
        return undefined;
      }
    },
    /**
     * 店铺选择器确认
     * @param items
     */
    handleShopPickerConfirm(items) {
      if (!items.length) return;
      this.shopItem = items[0];
      this.link = {
        type: "shop-home",
        value: items[0]["shop_id"],
      };
      this.$emit("update", this.link);
    },
    /**
     * 商品选择器确认
     * @param items
     */
    handleGoodsPickerConfirm(items) {
      if (!items.length) return;
      this.link = {
        type: "part-goods",
        value: items[0]["goods_id"],
      };
      this.$emit("update", this.link);
    },
    /**
     * 页面选择器确认
     * @param items
     */
    handlePagePickerConfirm(items) {
      if (!items.length) return;
      this.miniPageItem = items[0];
      this.link = {
        type: "mini-page",
        value: items[0].id,
      };
      this.$emit("update", this.link);
    },
  },
};
</script>

<style lang="scss" scoped>
.link-selector {
  position: relative;
  display: flex;
  width: 100%;
  .link-selector__link {
    display: inline-block;
    width: 100%;
  }
  ::v-deep {
    .el-tag {
      display: flex;
      align-items: center;
      position: relative;
      color: #155bd4;
      border-color: #155bd4;
      border-radius: 2px;
      width: 100%;
      height: 28px;
      box-sizing: border-box;
      margin-right: 5px;
      overflow: hidden;
      .el-tag__close {
        position: absolute;
        top: auto;
        right: 5px;
        color: #155bd4;
        &:hover {
          color: #ffffff;
          background-color: #155bd4;
        }
      }
      .link-selector__tag-content {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 10px;
        max-width: 208px;
      }
    }
    .el-cascader {
      width: 100%;
    }
  }
}
</style>
